import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { linkHelpers } from '../utils';
// import Rating from './Rating';

const Artwork = ({ artwork }) => {
  const { buildArtworkLink } = linkHelpers;
  const isSoldOut = artwork.countInStock === 0;
  return (
    <Card className={`my-3 rounded${isSoldOut ? ' artwork-sold-out' : ''}`}>
      <Link to={`/artwork/${artwork._id}`} className="artwork-img-link">
        <Card.Img src={buildArtworkLink(artwork.image)} variant="top" />
        {isSoldOut && <span className="sold-out-banner">Sold Out</span>}
      </Link>
      <Card.Body>
        <Link to={`/artwork/${artwork._id}`}>
          <Card.Title as="div" className="artwork-title mb-1">
            <strong>{artwork.name}</strong>
          </Card.Title>
        </Link>
        {/* <Card.Text as="div">
          <Rating
            value={artwork.rating}
            text={`${artwork.numReviews} reviews`}
          />
        </Card.Text> */}
        <Card.Text as="div" style={{ fontSize: '0.85rem' }}>${Object.values(artwork.price[0])[0]}</Card.Text>
      </Card.Body>
    </Card>
  );
};

export default Artwork;
